export default "__VITE_ASSET__BcjPS_H___"